const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Chats hoy: ",
          },
          entriesByHour: "Entradas por hora",
          pendingByHour: "Tickets en espera por hora",
          ticketsLabel: "Entradas",
          pendingLabel: "En espera"
        },
        metrics: {
          title: "Métricas de tickets",
          exactFrom: "Datos exactos desde la activación del tracking de estados",
          infoClose: "Cerrar",
          range: {
            label: "Rango",
            today: "Hoy",
            yesterday: "Ayer",
            last7Days: "Últimos 7 días",
            last30Days: "Últimos 30 días",
            last90Days: "Últimos 90 días"
          },
          filters: {
            firstResponseTarget: "Objetivo 1a respuesta (min)",
            resolutionTarget: "Objetivo resolución (min)"
          },
          firstResponseTime: "Tiempo medio de primera atención",
          firstResponseP50: "Primera atención P50",
          firstResponseP90: "Primera atención P90",
          resolutionTime: "Tiempo medio de resolución",
          resolutionP50: "Resolución P50",
          resolutionP90: "Resolución P90",
          pendingTime: "Tiempo medio en espera",
          pendingP50: "Espera P50",
          pendingP90: "Espera P90",
          openTime: "Tiempo medio en atención",
          openP50: "Atención P50",
          openP90: "Atención P90",
          slaFirstResponse: "SLA primera atención",
          slaResolution: "SLA resolución",
          peakEntryHour: "Hora pico de entrada",
          peakPendingHour: "Hora pico en espera",
          topResolvers: "Usuarios con más tickets resueltos",
          table: {
            user: "Usuario",
            resolved: "Resueltos",
            avgFirstResponse: "1a respuesta media",
            avgResolution: "Resolución media",
            slaFirstResponse: "SLA 1a resp.",
            slaResolution: "SLA resolución",
            reopened: "Reaperturas",
            active: "Activos",
            avgPerTicket: "Tiempo medio por ticket",
            noData: "No hay datos para este rango"
          },
          descriptions: {
            firstResponseTime: "Promedio del tiempo desde que entra un ticket hasta que pasa por primera vez a estado de atención.",
            firstResponseP50: "Percentil 50 de primera atención: la mitad de los tickets se atienden en este tiempo o menos.",
            firstResponseP90: "Percentil 90 de primera atención: el 90% de los tickets se atienden en este tiempo o menos.",
            slaFirstResponse: "Porcentaje de tickets que cumplen el objetivo de primera atención configurado arriba.",
            slaResolution: "Porcentaje de tickets resueltos dentro del objetivo de resolución configurado arriba.",
            peakEntryHour: "Franja horaria con mayor cantidad de tickets entrantes en el rango seleccionado.",
            peakPendingHour: "Franja horaria con más tickets en espera durante el rango seleccionado.",
            resolutionTime: "Promedio del tiempo total desde que entra un ticket hasta que se cierra.",
            resolutionP50: "Percentil 50 de resolución: la mitad de los tickets se cierran en este tiempo o menos.",
            resolutionP90: "Percentil 90 de resolución: el 90% de los tickets se cierran en este tiempo o menos.",
            pendingTime: "Promedio del tiempo acumulado que cada ticket pasa en estado de espera.",
            pendingP50: "Percentil 50 del tiempo en espera por ticket.",
            pendingP90: "Percentil 90 del tiempo en espera por ticket.",
            openTime: "Promedio del tiempo acumulado que cada ticket pasa en estado de atención.",
            openP50: "Percentil 50 del tiempo en atención por ticket.",
            openP90: "Percentil 90 del tiempo en atención por ticket.",
            topResolvers: "Ranking de usuarios con más tickets resueltos y sus tiempos promedio asociados."
          },
          examples: {
            firstResponseTime: "Ejemplo: ticket entra 10:00 y se atiende 10:12 -> primera atención = 12 min.",
            firstResponseP50: "Ejemplo: P50 = 8 min significa que 1 de cada 2 tickets se atiende en <= 8 min.",
            firstResponseP90: "Ejemplo: P90 = 25 min significa que 9 de cada 10 tickets se atienden en <= 25 min.",
            slaFirstResponse: "Ejemplo: objetivo 15 min y SLA 82% significa que 82 de cada 100 tickets se atendieron en <= 15 min.",
            slaResolution: "Ejemplo: objetivo 1440 min y SLA 76% significa que 76 de cada 100 tickets se cerraron en <= 1440 min.",
            peakEntryHour: "Ejemplo: 11:00 (34) significa que en la franja 11:00-11:59 entraron 34 tickets.",
            peakPendingHour: "Ejemplo: 15:00 (18) significa que en esa franja hubo 18 tickets distintos en espera.",
            resolutionTime: "Ejemplo: ticket entra 09:00 y se cierra 13:30 -> resolución = 4 h 30 min.",
            resolutionP50: "Ejemplo: P50 = 2 h significa que la mitad de los tickets se resuelven en <= 2 h.",
            resolutionP90: "Ejemplo: P90 = 14 h significa que el 90% se resuelve en <= 14 h.",
            pendingTime: "Ejemplo: si un ticket estuvo 20 min en espera y luego 10 min más, su espera total es 30 min.",
            pendingP50: "Ejemplo: P50 espera = 12 min significa que la mitad de tickets esperó <= 12 min.",
            pendingP90: "Ejemplo: P90 espera = 55 min significa que el 90% esperó <= 55 min.",
            openTime: "Ejemplo: suma de todos los periodos en atención de un ticket.",
            openP50: "Ejemplo: P50 atención = 40 min significa que la mitad de tickets estuvo en atención <= 40 min.",
            openP90: "Ejemplo: P90 atención = 3 h 10 min significa que el 90% estuvo en atención <= ese tiempo.",
            topResolvers: "Ejemplo: un usuario con 120 resueltos y menor tiempo medio tendrá mejor posición en el ranking."
          }
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          id: "ID",
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los chats relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un chat para empezar a chatear.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Departamentos",
      },
      tickets: {
        toasts: {
            deleted: "El chat en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar chats y mensajes.",
        },
        inboxSearch: {
          placeholder: "Buscar en bandeja",
        },
        closedSearch: {
          placeholder: "Buscar por nombre o contacto",
        },
        buttons: {
          showMine: "Míos",
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Chat",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        assignWhatsappTitle: "Asignar linea al chat",
        connectionRequired: "Selecciona una linea de WhatsApp para continuar.",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          assign: "Asignar linea",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "En Espera",
        assignedHeader: "Atendiendo",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        noTicketsMessage:
          "No se encontraron chats con este estado o término de búsqueda",
        buttons: {
          accept: "ACEPTAR",
        },
      },
      ticketListItem: {
        noQueue: "Sin departamento",
        status: {
          pending: "Pendiente de aceptar",
          open: "Atendiendo",
          closed: "Resuelto",
        },
        tooltips: {
          agent: "Agente",
          line: "Linea",
          queue: "Departamento",
        },
      },
      newTicketModal: {
        title: "Crear Chat",
        fieldLabel: "Busca un contacto o escribe un numero",
        add: "Añadir",
        addNumber: "Abrir chat con",
        countryCode: "Prefijo",
        connection: "Linea",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      paymentModal: {
        title: "Generar Link de Pago Seguro",
        form: {
          amount: "Importe (€)",
          concept: "Concepto",
        },
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      scheduleModal: {
        title: "Consultar Citas Disponibles",
        buttons: {
          ok: "Enviar Citas",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Chats",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Departamentos",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
          systemChecks: "Comprobaciones",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Departamentos",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los chats en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Departamentos",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los chats abiertos de los usuarios se moverán a la cola.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          ticketLockByAgent: {
            name: "Bloqueo de atencion por agente",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
        sections: {
          appointments: "Configuración de Citas",
          appwrite: "Configuración de Appwrite",
          admin: "Acciones de Administrador",
          deleteTickets: "Eliminar todos los chats y mensajes",
        },
        buttons: {
          save: "Guardar Configuración",
          delete: "Eliminar",
        },
      },
      appUpdate: {
        message: "Hay una nueva versión disponible.",
        warning: "Al actualizar se cerrará tu sesión y se limpiarán datos locales.",
        action: "Actualizar ahora",
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          missingWhatsapp: "Sin linea",
          missingWhatsappAlert:
            "Este chat no tiene una linea de WhatsApp asignada. Asigna una linea existente para responder o resolverlo.",
          buttons: {
            return: "Devolver",
            transfer: "Transferir",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            assignWhatsapp: "Asignar linea",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escribe un mensaje o presiona / para respuestas rápidas",
        placeholderMissingWhatsapp: "Asigna una linea de WhatsApp para responder.",
        placeholderClosed:
          "Vuelva a abrir o acepte este chat para enviar un mensaje.",
        signMessage: "Firmar",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
            title: "¿Borrar chat #",
          titleFrom: "del contacto ",
          message:
              "¡Atención! Todos los mensajes relacionados con el chat se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      backendErrors: {
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED: "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un chat abierto para este contacto.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún chat con este ID.",
        ERR_TICKET_NO_WHATSAPP:
          "Este chat no tiene una linea de WhatsApp asignada.",
        ERR_CREATING_TICKET: "Error al crear el chat en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
      },
    },
  },
};

export { messages };
